import { render, staticRenderFns } from "./RecommendationCard.vue?vue&type=template&id=5e103062&scoped=true&"
import script from "./RecommendationCard.vue?vue&type=script&lang=ts&"
export * from "./RecommendationCard.vue?vue&type=script&lang=ts&"
import style0 from "./RecommendationCard.vue?vue&type=style&index=0&id=5e103062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e103062",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VIcon,VImg,VLayout,VRow,VSkeletonLoader})
